
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Chart from '../../mixins/Chart.vue'
import { ChartOptions } from 'chart.js'

@Component
export default class PolarArea extends Mixins(Chart) {
  /**
   * Chart type.
   */
  public readonly chartType: string = 'polarArea'

  /**
   * Global default options.
   */
  public readonly defaultChartOptions: ChartOptions = {
    legend: {
      labels: {
        fontSize: 13
      }
    },
    scales: {
      xAxes: [
        {
          display: false
        }
      ],
      yAxes: [
        {
          display: false
        }
      ]
    }
  }
}
